import { render, staticRenderFns } from "./shopAlipayQrcodeAuth.vue?vue&type=template&id=1a99391c&scoped=true"
import script from "./shopAlipayQrcodeAuth.vue?vue&type=script&lang=ts"
export * from "./shopAlipayQrcodeAuth.vue?vue&type=script&lang=ts"
import style0 from "./shopAlipayQrcodeAuth.vue?vue&type=style&index=0&id=1a99391c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a99391c",
  null
  
)

export default component.exports